<template>
  <modal
    id="assessment-submit"
    :size="'md'"
    :confirm-text="'Submit Inbox'"
    confirm-class="btn-primary"
    close-class="btn-default pull-left"
    :close-text="`Back`"
    :show-exit="true"
    :show-close="true"
    @confirm="completeAssessment"
  >
    <template v-slot:title><h1>Submit Inbox</h1></template>
    <template v-slot:body>
      <strong>You are about to submit your inbox.</strong> The results will be available when your
      administrator releases them.
    </template>
  </modal>
</template>

<script>
  import Modal from '@shared/Modal.vue';
  export default {
    components: {
      Modal,
    },

    methods: {
      async completeAssessment() {
        this.$emit('confirm', true);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .box {
    background: #eef6f9;
  }
</style>
